module.exports = __webpack_public_path__ + "media/images/views/client/home/benefit-1-dce1dfbb0dc883dc229ac6c07e4cd914.png";